<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <p>{{ this.$t('companyTicket.description') }}</p>

      <div class="mc-company-tickets">
        <McTable
          withCard
          searchable
          stickyHeader
          :hasCheckbox="false"
          :hasSelectAll="false"
          :fields="fields"
          :apiClient="apiClient"
        >
          <template #cell(updated_at)="data">
            {{ momentDateShortMonth(data.item.updated_at) }}
            <div class="text-secondary">
              {{ momentTimeSeconds(data.item.updated_at) }}
            </div>
          </template>
          <template #cell(action)="data">
            <McButton
              variant="primary"
              size="sm"
              :text="$t('companyTicket.tickets.seeDetail')"
              @click="openDetailTicket(data)"
            />
          </template>
        </McTable>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McTable from '@/components/McTable'
import McButton from '@/components/McButton'
import { Helper } from '@/mixin/helper'
import * as companyTicketApi from '@/services/rest-api-vsms/lib/company-ticket/companyTicket'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  page: {
    title: 'Company Ticket',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McTable,
    McButton,
  },
  mixins: [Helper, MixPanel],
  computed: {
    title() {
      return this.$t('companyTicket.title')
    },
    fields() {
      return [
        { label: 'No Pengaduan', key: 'ticket_id', isSortable: true },
        { label: 'Status', key: 'ticket_status', isSortable: true },
        { label: 'Deskripsi', key: 'ticket_subject', isSortable: true },
        { label: 'Nama Produk', key: 'product_name', isSortable: true },
        { label: 'Tanggal Update Terakhir', key: 'updated_at', isSortable: true },
        { label: 'Diadukan Oleh', key: 'requested_by', isSortable: true },
        { label: '', key: 'action' },
      ]
    },
    apiClient() {
      return {
        get: async (data) => {
          if (!this.$store.state.identity.whoami) return
          const companyId = this.$store.state.identity.whoami.companyId
          let params = {
            companyId: companyId,
            data: data,
          }
          return await companyTicketApi.get(params)
        },
      }
    },
  },
  methods: {
    openDetailTicket(data) {
      this.mixpanelNotif('Click Pengaduan Detail')
      window.open(data.item.ticket_public_url, '_blank')
    },
    mixpanelNotif(event) {
      this.track(event, {
        user_name: this.$store.state.identity.whoami?.name,
        email: this.$store.state.identity.whoami?.email,
        company_name: this.$store.state.identity.whoami?.companyName,
        access_right: this.$store.state.identity.whoami?.accessRight,
      })
    },
  },
  mounted() {
    this.mixpanelNotif('Click Pengaduan')
  },
}
</script>

<style lang="scss" scoped>
.mc-company-tickets {
  .__status-dots {
    display: inline-block;
    margin: auto;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
  }

  .mc-text-status {
    font-weight: 600;
  }

  &__delivery-number {
    cursor: pointer;
  }
}
</style>
